import { styled } from '@mui/material';

export const PatientInfoWrapper = styled('div')({
  padding: '0 20px 20px 20px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
});

export const PatientName = styled('div')({
  display: 'flex',
  fontSize: '16px',
  fontWeight: 500,
  marginBottom: '10px',
  cursor: 'default'
});

export const PatientInfo = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '6px'
});

export const PatientDetails = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  letterSpacing: '0.15px',
  alignItems: 'center'
});

export const PatientRp = styled('span')({
  borderRadius: 4,
  marginRight: 8,
  border: '1px solid #000',
  padding: '2px 3px',
  fontSize: '10px'
});
